import { Component, OnInit, Inject } from "@angular/core";
// import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ClipBoardService } from "../../../services/clipboard.service";
import { ServerService } from "../../../services/server.service";
@Component({
  selector: "app-client-notification",
  templateUrl: "./client-notification.component.html",
  styleUrls: ["./client-notification.component.scss"],
})
export class ClientNotificationComponent implements OnInit {
  clientNotification!: FormGroup;
  btnStatus = false;
  toggle = false;
  selectAllPlatforms = false;
  token = localStorage.getItem('token')
  error:any[] = [];
 
  clientUserNoticationList:any;
  
  originalClientList:any;
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ClientNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}
  clientNotify = false;
  ngOnInit() {
    this.getUser()
    // this.getClientNotification();
   
  }
  // 

  getUser(){
    let url = 'client_notifications/users';
    let body = {
        "project_id": this.data.id
    }
    this.serverService.getUserNotificationList(url,body,this.token).subscribe((data)=>{
      // console.log(data)
      this.clientUserNoticationList = data;
      this.clientUserNoticationList.forEach(user => {
        // if()
        // const notif = user.client_notifications[0];

        const notif = Array.isArray(user.client_notifications) && user.client_notifications.length > 0
        ? user.client_notifications[0]
        : null;
        if (!notif) {
          return;
        }
        user.clientNotify = !!notif;
        // user.id = notif.id;
        // user.id = notif ? notif.id : null;
        user.id = notif.id;
        user.mobileApp_notify = notif.app_enabled || false;
        user.user_id = notif.user_id;
        user.email_notify = notif.email_enabled || false;
        user.whatsapp_notify = notif.whatsapp_enabled || false;
        user.selectAllPlatforms = user.mobileApp_notify && user.email_notify && user.whatsapp_notify;
      });
      this.originalClientList = JSON.parse(JSON.stringify(this.clientUserNoticationList));
      // console.log(this.originalClientList)
    })
   
  }
  // getClientNotification(){
  //   let url = 'client_notifications?project_id='+this.data.id;
    
  //   this.serverService.getUserNotification(url,this.token).subscribe((data)=>{
  //     console.log(data)
  //   })
  // }
  
  close() {
    this.dialogRef.close();
  }

  send() {
    // debugger;
    this.error = new Array(this.clientUserNoticationList.length).fill(false);
    const actionList = [];
  
    for (let i = 0; i < this.clientUserNoticationList.length; i++) {
      const original = this.originalClientList[i];
      const current = this.clientUserNoticationList[i];
      // console.log(current)
      if (current.clientNotify &&
        !current.mobileApp_notify &&
        !current.email_notify &&
        !current.whatsapp_notify) {
        this.error[i] = true;
        break;
      }
  
      const originalNotify = original.client_notifications.length > 0;
      const currentNotify = current.clientNotify;
  
      const originalApp = original.mobileApp_notify;
      const originalEmail = original.email_notify;
      const originalWhatsApp = original.whatsapp_notify;
  
      const currentApp = current.mobileApp_notify;
      const currentEmail = current.email_notify;
      const currentWhatsApp = current.whatsapp_notify;
  
      // DELETE
      if (originalNotify && !currentNotify) {
        actionList.push({
          id: current.id,
          name: current.name,
          email: current.email,
          action_type: 'remove',
          user_id:current.user_id,
          app_enabled: originalApp,
          email_enabled: originalEmail,
          whatsapp_enabled: originalWhatsApp
        });
      }
  
      // CREATE
      else if (!originalNotify && currentNotify) {
        actionList.push({
          // id: current.id,
          name: current.name,
          email: current.email,
          action_type: 'create',
          user_id:current.id,
          app_enabled: currentApp,
          email_enabled: currentEmail,
          whatsapp_enabled: currentWhatsApp
        });
      }
  
      // UPDATE
      else if (originalNotify && currentNotify) {
        if (
          originalApp !== currentApp ||
          originalEmail !== currentEmail ||
          originalWhatsApp !== currentWhatsApp
        ) {
          actionList.push({
            id: current.id,
            name: current.name,
            email: current.email,
            user_id:current.user_id,
            action_type: 'update',
            app_enabled: currentApp,
            email_enabled: currentEmail,
            whatsapp_enabled: currentWhatsApp
          });
        }
      }
    }
  
    // console.log("Action List:", actionList);
    let url="client_notifications"
    let body = {
      "project_id": this.data.id,
    "client_notification":actionList
    }
    this.serverService.updateClientNotification(url,body,this.token).subscribe((data)=>{
      this.clipBoardService.showMessgeInText('Client Notification Setting Updated Successfully', 'success-snackbar')
      this.dialogRef.close(data)
    })
  }
  
  
  
  onNotifyToggle(checked: boolean, index: number) {
    const client = this.clientUserNoticationList[index];
    client.clientNotify = checked;
    if (!checked) {
      client.selectAllPlatforms = false;
      client.mobileApp_notify =  false;
      client.email_notify =  false;
      client.whatsapp_notify = false;
    }
  }
  
  clientNotificationBox(event:any){
    // this.clientNotify = !this.clientNotify
    this.clientNotify = event.checked;
  }
  switchToggle(){
    this.toggle = !this.toggle;
  }
  
  toggleSelectAllPlatforms(index: number,event:any) {
    // debugger;
    const client = this.clientUserNoticationList[index];
    const isChecked = event.checked;
    // console.log()
    client.mobileApp_notify = isChecked;
    client.email_notify = isChecked;
    client.whatsapp_notify = isChecked;
  }
  
  onIndividualPlatformChange(index: number) {
    const client = this.clientUserNoticationList[index];
    // const { mobileApp, email, whatsapp } = client.platforms;
    const  whatsapp = client.whatsapp_notify
    const  mobileApp = client.mobileApp_notify
    const  email = client.email_notify
    client.selectAllPlatforms = mobileApp && email && whatsapp;
  }
}




